import type { EntityType } from '@erp-attach/shared';
import { Button } from './ui/Button';

const KIND_LABEL: Record<EntityType, string> = { customer: 'customer', site: 'job', supplier: 'supplier' };

/** Spec §7: a deep link that arrives before the poller has seen the entity shows this, never a 404. */
export function ProvisioningState({
  kind,
  number,
  name,
  onRetry,
}: {
  kind: EntityType;
  number: string;
  name?: string | null;
  onRetry?: () => void;
}) {
  return (
    <div className="gsl-panel mx-auto max-w-xl px-6 py-8 text-center" role="status">
      <p className="gsl-display text-2xl">Provisioning</p>
      <p className="mt-3 text-sm">
        This record is not in the attachment store yet. The {KIND_LABEL[kind]}{' '}
        <span className="gsl-num font-medium">{number}</span>
        {name ? <> ({name})</> : null} exists in Oracle Fusion; its folders are created on the next sync (every 10
        minutes).
      </p>
      {onRetry ? (
        <div className="mt-5">
          <Button variant="secondary" onClick={onRetry}>
            Check again
          </Button>
        </div>
      ) : null}
    </div>
  );
}
